export const errorTypes = {
    card: 'card',
    other: 'other',
};
